import { BettingAdvisory } from '@pickleballinc/ui/components/global/betting/BettingAdvisory';
import CustomLink from '@pickleballinc/ui/components/ui/custom-link';

import { publicEnv } from '@/lib/env';
import { NewsCard } from '@/modules/homepage/NewsCard/NewsCard';
import { SmallNewsCard } from '@/modules/homepage/SmallNewsCard/SmallNewsCard';
import { NewsFormatType } from '@/types/homepage.types';
import { RenderNewsInterface } from '@/utils/actions/homepage/getNews';
import { getWithBaseUrl } from '@/utils/helpers/getWithBaseUrl';

export interface RenderNewsProps extends RenderNewsInterface {
  newsType: NewsFormatType;
}

export const RenderNews = ({
  authorFullName,
  description,
  externalUrl,
  imageAltText,
  imageUrl,
  newsType,
  publishDateDisplayed,
  slug,
  smallNewsCardImgUrl,
  title,
  categorySlug,
  isBetting,
}: RenderNewsProps) => {
  const newsURL = getWithBaseUrl(`/${categorySlug}/${slug}`);
  const cardContent =
    newsType === 'format-a' ? (
      <NewsCard
        url={newsURL}
        image={imageUrl}
        imageAltText={imageAltText}
        title={title}
        description={description}
        publishDateDisplayed={publishDateDisplayed}
        author={authorFullName}
      />
    ) : (
      <SmallNewsCard
        url={newsURL}
        image={smallNewsCardImgUrl || imageUrl}
        imageAltText={imageAltText}
        title={title}
        description={description}
        publishDateDisplayed={publishDateDisplayed}
        author={authorFullName}
      />
    );
  return externalUrl ? (
    <a
      className='hover:opacity-80'
      href={externalUrl}
      aria-label='Link to external news (Opens in new tab)'
      target='_blank'
      rel='noopener noreferrer'
    >
      {cardContent}
    </a>
  ) : (
    <>
      {isBetting ? (
        <BettingAdvisory pickleballHref={`${publicEnv.NEXT_PUBLIC_HOME_ROOT_URL}`} />
      ) : null}
      <CustomLink className='hover:opacity-80' href={`/${categorySlug}/${slug}`} target='_self'>
        {cardContent}
      </CustomLink>
    </>
  );
};
